import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import store from '../../../store.js';

import {
  changeProject,
  loadProjects,
  loadUserPermissions,
  selectProjects,
  selectUserProjects,
  selectProjectsLoading,
  selectProjectUuid,
} from './projectSlice';

import { Select, Tag } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';

const selectStyles = {
  container: {
    marginLeft: 24,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  icon: {
    color: '#1890ff',
    fontSize: 16,
  },
  select: {
    minWidth: 180,
  },
};

export default function ProjectItem() {
  const userProjects = useSelector(selectUserProjects);
  const projects = useSelector(selectProjects);
  const projectUUID = useSelector(selectProjectUuid);
  const projectsLoading = useSelector(selectProjectsLoading);

  function handleProjectChange(uuid) {
    // Update Redux state
    store.dispatch(changeProject(uuid));
    // Navigate to new URL with hard reload to ensure all components refresh
    let path = window.location.pathname.split('/');
    path[1] = uuid;
    window.location.href = path.join('/');
  }

  useEffect(() => {
    store.dispatch(loadUserPermissions());
    store.dispatch(loadProjects());
  }, []);

  // Use userProjects if available (new API), otherwise fall back to projects (old API)
  const projectList = userProjects && userProjects.length > 0
    ? userProjects
    : projects.map(p => ({ uuid: p.uuid, name: p.alias, role: p.role }));

  // Filter out any invalid projects and ensure unique keys
  const validProjects = (projectList || []).filter(
    (p) => p && p.uuid
  );

  return (
    <div style={selectStyles.container}>
      <AppstoreOutlined style={selectStyles.icon} />
      <span style={{ fontWeight: 500, color: '#333' }}>Project:</span>
      <Select
        onChange={handleProjectChange}
        value={projectUUID || undefined}
        style={selectStyles.select}
        loading={projectsLoading}
        placeholder="Select project"
        bordered={true}
        size="middle"
      >
        {validProjects.map(({ uuid, name, role }) => (
          <Select.Option key={uuid} value={uuid}>
            <span style={{ marginRight: role ? 8 : 0 }}>{name || uuid}</span>
            {role && (
              <Tag
                color={role === 'admin' ? 'blue' : 'default'}
                style={{ fontSize: 10, lineHeight: '16px', padding: '0 4px' }}
              >
                {role}
              </Tag>
            )}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
}
